import RDCD from '../../reactivate-did-confirmation/reactivateDidConfirmation.js'

export default class ReactivateDidController {
  constructor($mdDialog, DidListService, ToastService) {
    'ngInject'
    this.$mdDialog = $mdDialog
    this.DidListService = DidListService
    this.TS = ToastService
    this.reactivateButtonDisabled = false
  }

  reactivateDid() {
    const data = {
      phone_number: this.did.number,
      rotate: false,
    }
    const uriData = {
      company: this.company,
      campaign: this.campaign,
      pool: this.pool,
    }
    this.reactivateButtonDisabled = true
    this.DidListService.buyDid
      .post(data, uriData)
      .then(data => {
        let rotatedNumber = data.number ? data.number : null
        if (rotatedNumber) {
          RDCD.locals = {
            did: this.did,
            pool: this.pool,
            company: this.company,
            campaign: this.campaign,
            rotatedNumber,
          }
          this.$mdDialog.show(RDCD)
        } else {
          console.error('Reactivate DID number not returned')
          this.TS.show({
            text: 'Error while reactivating DID number',
          })
        }
      })
      .catch(err => {
        console.error(err)
        this.TS.show({
          text: 'Error while reactivating did',
        })
      })
      .finally(() => {
        this.reactivateButtonDisabled = false
        this.refreshDidList()
      })
  }

  close() {
    this.$mdDialog.destroy()
  }
}
